/**
* @Description 文件功能说明：轮询  身份证刷卡
* @Author CC
* @Time 2021/7/3
**/

/* HTML */
<template>
</template>

/* JS */
<script>
	// 公共变量
	import GlobalVariable from '@/global/global-variable'
//	import ApiNfcWs from '@/request/api-nfc_ws'

    export default {

	    /**
	     * @Des 组件名
	     * @Auth CC
	     * @Date 2021/07/03
	     */
        name: "NFCIDCardSub",
        props:{
            // 休眠时间 毫秒
            time_fresh_nfc: {
                type: Number,
                default: function () {
                    return (3 * 1000)
                }
            },
            // 身份证信息 回显
            dataNFCMsg: {
            	type: Function,
                default: null
            },
        },
        data() {
        	return {
				// 延时计时器
				timer_nfc: null,
				// 开关 可轮询NFC
				canVisitNFC: true,
        	}
        },
        created() {
            // 轮询NFC数据  身份证
			this.startNfcIntval();
        },
        mounted () {

        },
        methods: {
			/**
			 * @Des 读取NFC IDCard 数据
			 * @Auth
			 * @Date 2021/11/20
			 */
            readNFCData() {
            	return false;

            	// 清除计时器
				if(this.timer_nfc != null) {
					clearTimeout(this.timer_nfc);
					this.timer_nfc = null;
				};

				// 可访问 NFC 数据接口 身份证
				if(!this.canVisitNFC) return false;

            	// 交互 读取 IDCard 信息
            	this.$request.postJsonRequest(ApiNfcWs.readIDCard, {
                    random: Math.random()
                }, 'get', {
                	headers: {
                		common: {Accept: "*/*"},
                		'Content-Type': 'application/x-www-form-urlencoded'
                	}
                }).then(result => {
                    // 可访问 NFC 数据接口 身份证
					if(!this.canVisitNFC) return false;

                    // 状态码不为0 中止 重新轮询
					if(result.ret != 0) {

						// 可访问 NFC 数据接口 身份证
						this.canVisitNFC = true;
						//轮询NFC数据  身份证
						this.startNfcIntval();

						return false;
					};

					// 封装NFC数据 json
					var dataObj = {};

					var oCertificate = result.Certificate;

					//与后台进行身份证信息匹配
					//matchCardData(oCertificate.IDNumber);

					var birthday = oCertificate.Birthday;

					var birthY = birthday.substr(0, 4);
					var birthM = birthday.substr(4, 2);
					var birthD = birthday.substr(6, 2);

					var birthStr = [birthY, birthM, birthD].join('-');

					dataObj['type'] = 'user';
					dataObj['userName'] = oCertificate.Name;//'张三'
					dataObj['sex'] = oCertificate.Sex;//'男';
					dataObj['birth'] = birthStr;//'1969-06-19';
					dataObj['idCard'] = oCertificate.IDNumber;//'149965196906193688';
					dataObj['PhotoName'] = encodeURI(oCertificate.PhotoName);
					dataObj['Base64Photo'] = oCertificate.Base64Photo;

					// 身份证信息 回显
					this.dataNFCMsg && this.dataNFCMsg(dataObj);

					// 轮询NFC数据  身份证
					this.startNfcIntval();

                }).catch(error => {
                    console.error('error readNFCData');

                    // 重新轮询
                    if (this.canVisitNFC) {
                    	// 轮询NFC数据  身份证
                    	this.startNfcIntval();
                    }

                    return false;
                });
            },

			/**
			 * @Des 轮询NFC数据  身份证
			 * @Auth
			 * @Date 2021/6/19
			 */
			startNfcIntval() {
				// 清除计时器
				if(this.timer_nfc) {
					clearTimeout(this.timer_nfc);
					this.timer_nfc = null;
				};

				// 可访问 NFC 数据接口 身份证
				if(!this.canVisitNFC) return false;

				this.timer_nfc = setTimeout(() => {
					// 轮询 读取 NFC设备
					this.readNFCData();
				}, this.time_fresh_nfc);
			},
			endReadNFC() {
				// 清除计时器
				if(this.timer_nfc) {
					clearTimeout(this.timer_nfc);
					this.timer_nfc = null;
				};
				// 更改可访问状态
				this.canVisitNFC = false;
			}
        },
        // 销毁
        destroyed() {
        	// 关闭 轮询
			this.endReadNFC();
        }

    }
</script>



// WEBPACK FOOTER //
// src/components/NFCIDCardSub.vue